import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const RefundRedirect = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate('/privacy#refund', { replace: true });
    }, [navigate]);

    return null;
};

export default RefundRedirect;
